import { Card } from 'antd';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface RevenueChartProps {
  data: { date: string; mrr_usd: number; arr_usd: number }[];
  loading?: boolean;
}

export function RevenueChart({ data, loading }: RevenueChartProps) {
  return (
    <Card title="Revenue Trend" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip formatter={(value: number) => `$${value.toLocaleString()}`} />
          <Area type="monotone" dataKey="mrr_usd" name="MRR" stroke="#1677ff" fill="#1677ff" fillOpacity={0.1} />
          <Area type="monotone" dataKey="arr_usd" name="ARR" stroke="#52c41a" fill="#52c41a" fillOpacity={0.1} />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  );
}
